export interface IVAPagingRes {
  count: number;
  next: null;
  previous: null;
  numero_paginas: number;
  data: IVA[];
}

export interface IVA {
  id_iva?: string;

  nombre: string;

  sri_codigo: string;
  sri_codigo_porcentaje: string; // valor porcentual

  porcentaje: string; // valor porcentual
  estado: boolean;

  codigo: string;
  numero_referencia?: string;

  fecha_creacion?: string;
  fecha_modificacion?: string;
}

export enum IVAEnumSelect {
  IVA_0_CODE = 'IVA 0%',
  IVA_0_VALUE = 0,
}
